import { Image } from '@components/common/Image';
import { RenderHTMLText } from '@components/common/WYSIWYG/RenderHTMLText';
import { FunctionComponent } from 'react';
import { Container, Content, Thumbnail } from './ArticleContent.styles';
import { ArticleContentProps } from './ArticleContent.types';

export const ArticleContent: FunctionComponent<ArticleContentProps> = ({
  thumbnail,
  value,
  children,
  ads,
}) => {
  return (
    <Container>
      {thumbnail && (
        <Thumbnail>
          {/* TODO: fix swagger schema for images */}
          {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
          {/* @ts-ignore */}
          <Image url={thumbnail?.hash} caption={thumbnail?.caption} alternativeText={thumbnail?.alternativeText} />
        </Thumbnail>
      )}
      <Content>
        {children}
        <RenderHTMLText wysiwygData={value} ads={ads} />
      </Content>
    </Container>
  );
};
